export const GET_CONTACTS = "GET_CONTACTS";
export const GET_CONTACT_BY_ID = "GET_CONTACT_BY_ID";
export const UPDATE_CONTACT = "UPDATE_CONTACT";
export const DELETE_CONTACT = "DELETE_CONTACT";
export const CREATE_CONTACT = "CREATE_CONTACT";
